<!-- 价格策略操作 -->
<template>
	<div>
		<subComponents  ref="showSelectData"></subComponents>
		<el-dialog :visible.sync="dataActionBox.showStatus" :title="dataActionBox.boxTitle"  append-to-body :close-on-click-modal="false" center  width="50%" top="2rem">
			<el-form size="mini" label-position="top" label-width="200px">
				<el-form-item label="价格策略分组">
					<el-input v-model.trim="sendDataInfo.prgGname" @focus="$refs['showSelectData'].openBox('priceStrategyGroupList','priceStrategyGroupList','prgId')"></el-input>
				</el-form-item>
				<el-form-item label="商品">
					<el-input   v-model.trim="sendDataInfo.bgmName" clearable @focus="$refs['showSelectData'].openBox('businessGoodsList','bgmId','bgmId')"></el-input>
				</el-form-item>
				<el-form-item label="最低扣率">
					<el-input   v-model="sendDataInfo.pmMinderate" type="number"></el-input>
				</el-form-item>
				<el-form-item label="最低售价">
					<el-input   v-model="sendDataInfo.pmMinprice" type="number"></el-input>
				</el-form-item>
				<el-form-item label="售价">
					<el-input   v-model="sendDataInfo.pmPrice" type="number"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dataActionBox.showStatus = false">取消</el-button>
				<el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==0">保存</el-button>
				<el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==1">保存</el-button>
			</div>
		</el-dialog>
	</div>
	
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
	name:'priceStrategyAction',
	props:[],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
			dataActionBox:{
				showStatus:false,
				boxTitle:'新增'||'编辑',
				actionType:0, // 0新增，1修改
			},
			sendDataInfo:{
				prgId: "",
				prgGname: "",
				bgmName:"",
				bgmId:"",
				pmMinderate:"",
				pmMinprice:"",
				pmPrice:"",
				pmState:"",
			},
			
        };
    },
    //监听属性 类似于data概念
    computed: {
	},
    //监控data中的数据变化
    watch: {
	},
    //方法集合
    methods: {
		initActionBox(){
			for(let key in this.sendDataInfo){
				this.sendDataInfo[key]  = ''
			}
		},
		
		isShowData(name,value){
			switch(name){
				case 'priceStrategyGroupList':
					var dataInfo = sessionStorage.getItem('selectPriceStrategyGroupData')
					if(dataInfo){
						dataInfo = JSON.parse(dataInfo)
						this.sendDataInfo.prgId = dataInfo.prgId
						this.sendDataInfo.prgGname = dataInfo.prgGname
					}
				break;
				case 'bgmId':
					var dataInfo = sessionStorage.getItem('selectBusinessGoodsEntryInfo')
					if(dataInfo){
						dataInfo = JSON.parse(dataInfo)
						this.sendDataInfo.bgmId = dataInfo.bgmId
						this.sendDataInfo.bgmName = dataInfo.bgmName
					}
				break;
				default:
					this.sendDataInfo[name] = value
				
			}
		},
		
	
		
		openBox(cate,oldData=''){
			this.initActionBox()
			if(cate == 0){
				this.dataActionBox.boxTitle = '新增价格策略'
			}else{
				this.dataActionBox.boxTitle = '编辑价格策略'
				this.sendDataInfo  = oldData
			}
			this.dataActionBox.actionType = cate
			this.dataActionBox.showStatus = true
			
		},
		async sendDataAction(){
			if(this.sendDataInfo.prgId==''){
				this.$message({
					message: '请选择价格策略分组',
					type: 'error'
				});
				return false
			}
			if(this.sendDataInfo.bgmId==''){
				this.$message({
					message: '请选择商品',
					type: 'error'
				});
				return false
			}
		
			
			var newSendDataInfo = JSON.parse(JSON.stringify(this.sendDataInfo))
		
			if(this.dataActionBox.actionType==0){
				var responseData =  await this.$http.addPriceStrategy(newSendDataInfo)
			}else{
				var responseData =  await this.$http.setPriceStrategy(newSendDataInfo)
			}
			
			
			if(responseData.status == 200){
				this.dataActionBox.showStatus = false
				this.$message({
					message: '操作成功',
					type: 'success'
				});
				this.$parent.getDataList()
				
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
	
		
		
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
	}, //生命周期 - 创建之前
    beforeMount() {
	}, //生命周期 - 挂载之前
    beforeUpdate() {
	}, //生命周期 - 更新之前
    updated() {
	}, //生命周期 - 更新之后
    beforeDestroy() {
	}, //生命周期 - 销毁之前
    destroyed() {
	}, //生命周期 - 销毁完成
    activated() {
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>